import { useIntl } from '@weenat/wintl';
import noop from 'lodash-es/noop';
import { useRef } from 'react';
import schemas from '../../../schemas';
import useOrderedFields from '../../useOrderedFields';
const productQuantitySchema = schemas.decitrait.addProductDose;
/** @deprecated */
export const useDecitraitSelectedProduct = ({ product, optidoseQuantity, givenDose, onChange }) => {
    const formRef = useRef();
    const fieldProps = useOrderedFields(['quantity'], formRef);
    const { t } = useIntl();
    const initialValues = { quantity: givenDose || product.approvedDose };
    return {
        product,
        optidoseQuantity,
        props: {
            useOnChange: {
                onChange
            },
            form: {
                schema: productQuantitySchema,
                onSubmit: noop,
                initialValues,
                formRef
            },
            fields: {
                productDoseQuantity: {
                    ...fieldProps.quantity,
                    label: t('dss.decitrait.inputs.productDoseQuantity')
                }
            }
        }
    };
};
